import { render, staticRenderFns } from "./CellRendererType.vue?vue&type=template&id=06d24b1a"
import script from "./CellRendererType.vue?vue&type=script&lang=js"
export * from "./CellRendererType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports